var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78548C42.3036 6.46864 45.1137 6.46864 47.3945 7.78548L76.7314 24.7231C79.0122 26.04 80.4172 28.4736 80.4172 31.1072V64.9825C80.4172 67.6162 79.0122 70.0498 76.7314 71.3667L47.3945 88.3043C45.1137 89.6211 42.3036 89.6211 40.0227 88.3043L10.6859 71.3666C8.40504 70.0498 7 67.6162 7 64.9825V31.1072C7 28.4736 8.40504 26.04 10.6859 24.7231L40.0228 7.78548Z",
    fill: "#C9E9F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8837_45050",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.915C42.7172 11.8451 45.0004 11.8451 46.8535 12.915L72.7845 27.8863C74.6377 28.9562 75.7793 30.9335 75.7793 33.0734V63.0159C75.7793 65.1558 74.6377 67.1331 72.7845 68.203L46.8535 83.1742C45.0004 84.2442 42.7172 84.2442 40.864 83.1742L14.933 68.203C13.0798 67.1331 11.9382 65.1557 11.9382 63.0159V33.0733C11.9382 30.9335 13.0798 28.9562 14.933 27.8863L40.864 12.915Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8837_45050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8639 12.915C42.717 11.8451 45.0002 11.8451 46.8534 12.915L72.7844 27.8863C74.6376 28.9562 75.7792 30.9335 75.7792 33.0734V63.0159C75.7792 65.1558 74.6376 67.1331 72.7844 68.203L46.8534 83.1742C45.0002 84.2442 42.717 84.2442 40.8639 83.1742L14.9329 68.203C13.0797 67.1331 11.9381 65.1557 11.9381 63.0159V33.0733C11.9381 30.9335 13.0797 28.9562 14.9329 27.8863L40.8639 12.915Z",
    fill: "#1589BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.06C72.2298 83.5011 12.5546 43.3756 6.58582 9.86806L-27.8162 57.6638L55.5728 117.685L107.846 45.06Z",
    fill: "#006692"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8837_45050",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 82,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2998 8.42166C3.2998 5.11374 5.98141 2.43213 9.28934 2.43213H78.3993C81.7072 2.43213 84.3888 5.11373 84.3888 8.42166V49.9236C84.3888 52.2916 82.4692 54.2113 80.1012 54.2113C77.7332 54.2113 75.8136 56.1309 75.8136 58.4989V63.0136C75.8136 65.1547 74.6706 67.133 72.8157 68.2025L46.838 83.18C44.9853 84.2481 42.7037 84.2475 40.8517 83.1783L14.9121 68.203C13.0588 67.1331 11.9171 65.1558 11.9171 63.0159V58.5199C11.9171 56.1403 9.98809 54.2113 7.60848 54.2113C5.22886 54.2113 3.2998 52.2822 3.2998 49.9026V8.42166Z",
    fill: "#FCCE2C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8837_45050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0615 24.1809H39.1787V10.7827L44.0615 11.3052V24.1809Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6199 0.0439453H37.6646V11.0479H41.6199V0.0439453Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6201 0.0439453H39.1787V11.0479H41.6201V0.0439453Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1788 19.1588H36.1509V8.88005L39.1788 8.41992V19.1588Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2067 78H36.1509V16.6709C37.392 16.2732 40.6654 15.93 42.2067 16.4369V77.9922V78Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2067 17.9577V16.4448C40.6518 15.9301 37.392 16.2732 36.1509 16.6787V18.1761C37.8012 17.9187 40.4063 17.7472 42.2067 17.9577Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2067 29.2737V27.7607C40.6518 27.246 37.392 27.5969 36.1509 27.9947V29.492C37.8012 29.2347 40.4063 29.0631 42.2067 29.2737Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2065 78H45.9164V24.5242C45.098 24.0563 43.7205 23.7131 42.2065 23.7131V77.9922V78Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2065 27.7295V29.2736C43.7069 29.2736 45.0844 29.6168 45.9164 30.0847V28.5406C45.098 28.0726 43.7205 27.7295 42.2065 27.7295Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2065 44.4888V46.0329C43.7069 46.0329 45.0844 46.3761 45.9164 46.844V45.2998C45.098 44.8319 43.7205 44.4888 42.2065 44.4888Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9028 78.0001H48.9307V41.315C48.2624 40.847 47.1304 40.5039 45.9028 40.5039V78.0001Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9443 78H51.9722V56.0154C51.3039 55.5475 50.1719 55.2043 48.9443 55.2043V77.9922V78Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9722 78H55.0001V68.2594C54.3317 67.7915 53.1997 67.4484 51.9722 67.4484V78Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7607 77.9999H35.4551V35.4968C36.5462 35.0991 39.3968 34.756 40.7607 35.2629V77.9921V77.9999Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1788 78.0001H34.5278V51.1336C35.4826 50.7358 37.9922 50.3927 39.1788 50.8996V78.0001Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.651 78.0001H33V64.4147C33.9547 64.0169 36.4644 63.6738 37.651 64.1807V78.0001Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7607 45.9628V44.4499C39.4104 43.9352 36.5462 44.2783 35.4551 44.6839V46.1812C36.9008 45.9239 39.1786 45.7523 40.7607 45.9628Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2065 46.0331L40.7607 45.9629V44.45L42.2065 44.4889V46.0331Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2065 59.5483V61.0925C43.7069 61.0925 45.0844 61.4356 45.9164 61.9036V60.3594C45.098 59.8915 43.7205 59.5483 42.2065 59.5483Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9443 60.3516V61.8957C50.1719 61.8957 51.3039 62.2311 51.9722 62.7068V61.1626C51.3039 60.6947 50.1719 60.3516 48.9443 60.3516Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9028 45.292V46.8361C47.1304 46.8361 48.2624 47.1715 48.9307 47.6472V46.1031C48.2624 45.6351 47.1304 45.292 45.9028 45.292Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1788 61.0222V59.5092C37.9922 59.0023 35.4962 59.3454 34.5278 59.7432V61.2405C35.7963 60.9832 37.7876 60.8116 39.1788 61.0222Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2065 59.5483H40.7607V61.0925H42.2065V59.5483Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7609 61.0924L39.1787 61.0534V59.5093L40.7609 59.5483V61.0924Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9307 60.3516H45.9028V61.8957H48.9307V60.3516Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2065 24.181H44.0615V11.3053L42.2065 11.1104V24.181Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0615 16.632C43.4886 16.5228 42.8612 16.4448 42.2065 16.4448V17.9578C42.8612 17.9578 43.4886 18.0358 44.0615 18.1527V16.6242V16.632Z",
    fill: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 68.9999C41.5 68.9999 40.1667 72.3332 40 73.9999C33.6 73.9999 31.3333 77.9999 31 79.9999H63C62.6667 77.9999 61.4 73.6999 59 72.4999C56.6 71.2999 53 72.9999 51.5 73.9999C51.1667 72.3332 49.5 68.9999 45.5 68.9999Z",
    fill: "#006692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 65.9999C57.5 65.9999 56.1667 69.3332 56 70.9999C49.6 70.9999 47.3333 74.9999 47 76.9999H79C78.6667 74.9999 77.4 70.6999 75 69.4999C72.6 68.2999 69 69.9999 67.5 70.9999C67.1667 69.3332 65.5 65.9999 61.5 65.9999Z",
    fill: "#006692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 72.9999C57.5 72.9999 56.1667 76.3332 56 77.9999C49.6 77.9999 47.3333 81.9999 47 83.9999H79C78.6667 81.9999 77.4 77.6999 75 76.4999C72.6 75.2999 69 76.9999 67.5 77.9999C67.1667 76.3332 65.5 72.9999 61.5 72.9999Z",
    fill: "#006692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8594 67.9999C74.4844 67.9999 75.6927 71.3332 75.8438 72.9999C81.6438 72.9999 83.6979 76.9999 84 78.9999H55C55.3021 76.9999 56.45 72.6999 58.625 71.4999C60.8 70.2999 64.0625 71.9999 65.4219 72.9999C65.724 71.3332 67.2344 67.9999 70.8594 67.9999Z",
    fill: "#006692"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 29.5,
    r: 1.5,
    fill: "#FFE27D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 51.5,
    r: 1.5,
    fill: "#FFE27D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 66.9999,
    r: 1,
    fill: "#FFE27D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 48,
    r: 1,
    fill: "#FFE27D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 39.5,
    r: 0.5,
    fill: "#FFE27D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 55.5,
    r: 0.5,
    fill: "#FFE27D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 40.5,
    r: 0.5,
    fill: "#FFE27D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9999 26.7877C30.5566 26.8575 30.102 26.8937 29.6391 26.8937C24.8454 26.8937 20.9594 23.0077 20.9594 18.214C20.9594 16.6112 21.3938 15.1098 22.1514 13.8213C18.0042 14.4743 14.8325 18.0642 14.8325 22.3949C14.8325 27.1886 18.7186 31.0746 23.5122 31.0746C26.7031 31.0746 29.4918 29.3528 30.9999 26.7877Z",
    fill: "#FFE27D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.d4c13613919c6601a9a32c5942f26ddb.svg";
export { ForwardRef as ReactComponent };